import Technician from "../../modules/technicians/models/technician";
import ToolTip from "../base/ToolTip";

// 1 -> "1st", 2 -> "2nd", 3 -> "3rd", 4 -> "4th", 11 -> "11th", 21 -> "21st"...
function ordinal(n: number): string {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

interface IProps {
    tech: Pick<Technician, "metroPriority" | "metroPriorityName" | "typePriority" | "typePriorityName">
    className?: string
}

// Priority badges shown at the end of a technician option: the job-type priority
// (light-info) and the metro priority (light-primary), each with an "Nth choice
// for X" tooltip. Shared by the job form Select and the assign-tech drawer so both
// read identically. Renders nothing when the tech has no priority in either.
export default function TechPriorityBadges({ tech, className }: IProps) {

    if (!tech.typePriority && !tech.metroPriority) return null;

    return (
        <span className={`d-inline-flex align-items-center ${className ?? ""}`}>
            {
                !!tech.typePriority &&
                <ToolTip className="ms-1" content={
                    <><b>{ordinal(tech.typePriority)} choice</b> for {tech.typePriorityName ?? "this job type"}</>
                }>
                    <span className="badge badge-light-info fs-9">
                        {tech.typePriority}
                    </span>
                </ToolTip>
            }
            {
                !!tech.metroPriority &&
                <ToolTip className="ms-1" content={
                    <><b>{ordinal(tech.metroPriority)} choice</b> for {tech.metroPriorityName ?? "this metro"}</>
                }>
                    <span className="badge badge-light-primary fs-9">
                        {tech.metroPriority}
                    </span>
                </ToolTip>
            }
        </span>
    );
}
